import React, { useState, useEffect } from 'react';
import { Phone, Mail, Menu, X } from 'lucide-react';
import { companyInfo } from '../mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-white/95 backdrop-blur-md shadow-sm' 
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <h1 className={`text-2xl font-bold transition-colors duration-300 ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}>
              {companyInfo.name}
            </h1>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className={`font-medium transition-colors hover:text-amber-600 ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('portfolio')}
              className={`font-medium transition-colors hover:text-amber-600 ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Portfolio
            </button>
            <button
              onClick={() => scrollToSection('why-choose-us')}
              className={`font-medium transition-colors hover:text-amber-600 ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Why Choose Us
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`font-medium transition-colors hover:text-amber-600 ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Contact
            </button>
          </nav>

          {/* Contact Info - Desktop */}
          <div className="hidden lg:flex items-center space-x-6">
            <a 
              href={`tel:${companyInfo.phone}`}
              className={`flex items-center space-x-2 transition-colors hover:text-amber-600 ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              <Phone size={18} />
              <span className="text-sm font-medium">{companyInfo.phone}</span>
            </a>
            <a 
              href={`mailto:${companyInfo.email}`}
              className={`flex items-center space-x-2 transition-colors hover:text-amber-600 ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              <Mail size={18} />
              <span className="text-sm font-medium">{companyInfo.email}</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden p-2 rounded-lg transition-colors ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <nav className="px-4 py-6 space-y-4">
            <button
              onClick={() => scrollToSection('home')}
              className="block w-full text-left py-2 text-gray-700 font-medium hover:text-amber-600 transition-colors"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('portfolio')}
              className="block w-full text-left py-2 text-gray-700 font-medium hover:text-amber-600 transition-colors"
            >
              Portfolio
            </button>
            <button
              onClick={() => scrollToSection('why-choose-us')}
              className="block w-full text-left py-2 text-gray-700 font-medium hover:text-amber-600 transition-colors"
            >
              Why Choose Us
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left py-2 text-gray-700 font-medium hover:text-amber-600 transition-colors"
            >
              Contact
            </button>
            <div className="pt-4 border-t border-gray-200 space-y-3">
              <a 
                href={`tel:${companyInfo.phone}`}
                className="flex items-center space-x-2 text-gray-700 hover:text-amber-600 transition-colors"
              >
                <Phone size={18} />
                <span className="text-sm font-medium">{companyInfo.phone}</span>
              </a>
              <a 
                href={`mailto:${companyInfo.email}`}
                className="flex items-center space-x-2 text-gray-700 hover:text-amber-600 transition-colors"
              >
                <Mail size={18} />
                <span className="text-sm font-medium">{companyInfo.email}</span>
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
